<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="'SEO Page'"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="'SEO Page Create'"
      :title="'SEO Page Create'"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">URL</p>
          <div class="input-container">
            <InputText
              :onChange="setSeoName"
              :id="'url'"
              :label="'url'"
              :value="formDataToSend.url"
              :type="'text'"
              :placeholder="'URL'"
              :error-messages="validationErrors['url']"
              isBordered
            />
          </div>

          <p class="form-create__label">Title</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'title'"
              :label="'title'"
              :type="'text'"
              :placeholder="'Title'"
              :error-messages="validationErrors['title']"
              isBordered
            />
          </div>

          <p class="form-create__label">Description</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'description'"
              :label="'description'"
              :type="'text'"
              :placeholder="'Description'"
              :max-length="'255'"
              :error-messages="validationErrors['description']"
              isBordered
            />
          </div>

          <p class="form-create__label">H1</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'h1'"
              :label="'h1'"
              :type="'text'"
              :placeholder="'H1'"
              :error-messages="validationErrors['h1']"
              isBordered
            />
          </div>

          <p class="form-create__label">Annotation</p>
          <div class="input-container">
            <InputTextarea
              :set-value="formDataToSend"
              :id="'annotation'"
              :label="'annotation'"
              :placeholder="'Annotation'"
              :error-messages="validationErrors['annotation']"
              isBordered
            />
          </div>

          <p class="form-create__label">SEO Text</p>
          <div class="input-container">
            <TextEditor
              :set-value="formDataToSend"
              :id="'seo_text'"
              :placeholder="''"
              :error-messages="validationErrors['seo_text']"
            />
          </div>

          <p class="form-create__label">Script</p>
          <div class="input-container">
            <InputTextarea
              :set-value="formDataToSend"
              :id="'script'"
              :label="'script'"
              :placeholder="'Script'"
              :error-messages="validationErrors['annotation']"
              script
            />
          </div>

          <div class="form-create__radio-group">
            <div class="form-create__radio-group-item">
              <p class="form-create__label">FAQ</p>
              <div class="checkbox-container checkbox-container_margin">
                <div v-for="item in faqGroups" :key="item.id" class="checkbox-container__item">
                  <MainCheckbox
                    :label="item.name"
                    :id="item.id + ''"
                    :set-value="formDataToSend.faq_group"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-create__radio-group-item">
            <p class="form-create__label">Post List</p>
          </div>

          <div v-if="formDataToSend.posts">
            <div v-for="post in formDataToSend.posts" :key="post.id" class="form-create__list-post">
              {{ post.name }}
              <div @click="handleDeletePost(post)" class="form-create__list-post-plus rotate">
                +
              </div>
            </div>
          </div>

          <input
            v-model="postSearch"
            class="form-create__search"
            type="text"
            placeholder="Search post..."
            @input="debouncedGetPosts"
          />
          <div v-if="postList">
            <div v-for="post in postList" :key="post.id" class="form-create__list-post">
              {{ post.name }}
              <div @click="handleAddPost(post)" class="form-create__list-post-plus">+</div>
            </div>
          </div>

          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'active'" :set-value="formDataToSend" />
          </div>

          <div class="input-container">
            <MainCheckbox
              :label="'Noindex ATTENTION!!!!!!'"
              :id="'noindex'"
              :set-value="formDataToSend"
            />
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import faqApi from "~/api/faq";
import blogApi from "~/api/blog";
import { debounce } from "lodash";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import InputTextarea from "~/components/atoms/inputs/InputTextarea.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";
import TextEditor from "~/components/atoms/inputs/TextEditor.vue";

export default {
  name: "SeoCreate",
  metaInfo: {
    title: "SEO Page Create",
  },
  data() {
    return {
      formDataToSend: {
        h1: "",
        url: "",
        seo_text: "",
        script: "",
        active: false,
        noindex: false,
        annotation: "",
        title: "",
        description: "",
        faq_group: {},
        posts: [],
      },
      faqGroups: [],
      postSearch: "",
      postList: [],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    InputTextarea,
    MainCheckbox,
    TextEditor,
  },
  mounted() {
    this.getGroups();
  },
  computed: {
    ...mapState("statics", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.SEO_LIST.replace(":page", 1);
    },
  },
  methods: {
    handleSubmit() {
      const data = {
        seo_text: this.formDataToSend.seo_text,
        script: this.formDataToSend.script,
        h1: this.formDataToSend.h1,
        url: this.formDataToSend.url,
        active: this.formDataToSend.active,
        noindex: this.formDataToSend.noindex,
        annotation: this.formDataToSend.annotation,
        title: this.formDataToSend.title,
        description: this.formDataToSend.description,
      };

      const groups = Object.keys(this.formDataToSend.faq_group);
      if (groups.length) {
        let groupsSend = [];
        for (let i = 0; groups.length > i; i++) {
          if (this.formDataToSend.faq_group[groups[i]] == true) {
            groupsSend.push(groups[i]);
          }
        }
        if (groupsSend.length > 0) {
          data.faq_groups = groupsSend;
        }
      }

      if (this.formDataToSend.posts.length) {
        let postSend = [];
        for (let i = 0; this.formDataToSend.posts.length > i; i++) {
          postSend.push(this.formDataToSend.posts[i].id);
        }
        data.posts = postSend;
      }

      this.$store.dispatch("statics/createSeo", data);
    },
    debouncedGetPosts: debounce(function () {
      this.getPosts();
    }, 300),

    getPosts() {
      if (this.postSearch.trim().length > 0) {
        const data = {
          search: this.postSearch.trim(),
        };
        try {
          blogApi.getBlogPostsFilter("?perPage=20", data).then((res) => {
            this.postList = res.data.items.data;
          });
        } catch (error) {
          console.log(error);
        }
      }
    },

    handleAddPost(item) {
      const elem = this.formDataToSend.posts.find((i) => i.id == item.id);

      if (!elem) {
        this.formDataToSend.posts.push(item);
      }
    },

    handleDeletePost(item) {
      this.formDataToSend.posts = this.formDataToSend.posts.filter((i) => i.id !== item.id);
    },
    getGroups() {
      try {
        faqApi.getFaqGroups().then((res) => {
          const data = res.data.items;
          this.faqGroups = data;
          this.setGroups(data);
        });
      } catch (error) {
        console.log(error);
      }
    },
    setGroups(data) {
      const groups = data;
      for (let i = 0; groups.length > i; i++) {
        this.$set(this.formDataToSend.faq_group, groups[i].id, false);
      }
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.SEO_LIST.replace(":page", 1),
      });
    },
    setSeoName(data) {
      // const value = urlTransform(data);
      this.formDataToSend.url = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
.form-create {
  &__search {
    padding: 5px 10px;
    font-size: 18px;
    margin: 20px 0;
    width: 100%;
  }

  &__list-post {
    padding: 5px 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid grey;
    width: fit-content;
    display: flex;
    align-items: center;
  }

  &__list-post-plus {
    width: 30px;
    height: 30px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: green;
    color: #fff;
    margin-left: 10px;
    font-size: 20px;
    cursor: pointer;

    &.rotate {
      transform: rotate(45deg);
      background: red;
    }
  }
}
</style>
